'use client';

import { useCurrentURL } from '../../../../../helpers/hooks/useCurrentURL/useCurrentURL';
import { flowsURLParameters, URLParameters } from '../../../../../views/Authentication/constants';
import {
  IInternalLinkProps,
  NonCrawlableLink,
} from '../../../../Clickables/NonCrawlableLink/NonCrawlableLink';

export const LoginButton = ({
  onClick,
  buttonSize,
  className,
}: {
  onClick: () => void;
  buttonSize: IInternalLinkProps['size'];
  className?: string;
}) => {
  const { addParameters } = useCurrentURL();
  const loginLink = addParameters({ [URLParameters.Flow]: flowsURLParameters.login });
  return (
    <NonCrawlableLink
      variant="buttonSecondary"
      size={buttonSize}
      className={className}
      routerPushTo={loginLink}
      onClickEvent={onClick}
      ariaLabel="log in to Fishbrain"
    >
      Log in
    </NonCrawlableLink>
  );
};
